import "react-app-polyfill/stable";

import main from "./index";

main();
